export type Locale = "pt" | "en" | "es";

export const LOCALES: Locale[] = ["pt", "en", "es"];

export const DEFAULT_LOCALE: Locale = "pt";

export const LOCALE_HTML_LANG: Record<Locale, string> = {
  pt: "pt-BR",
  en: "en",
  es: "es",
};

export const LOCALE_LABEL: Record<Locale, string> = {
  pt: "Português",
  en: "English",
  es: "Español",
};

export const LOCALE_FLAG: Record<Locale, string> = {
  pt: "🇧🇷",
  en: "🇺🇸",
  es: "🇪🇸",
};

export function isLocale(value: unknown): value is Locale {
  return value === "pt" || value === "en" || value === "es";
}

/**
 * Extrai o locale do início do pathname.
 * "/en/contato" -> "en"; "/contato" -> "pt"
 */
export function getLocaleFromPathname(pathname: string): Locale {
  const seg = pathname.split("/").filter(Boolean)[0];
  if (seg === "en" || seg === "es") return seg;
  return "pt";
}

/**
 * Remove o prefixo de locale do pathname.
 * "/en/contato" -> "/contato"; "/contato" -> "/contato"
 */
export function stripLocale(pathname: string): string {
  const parts = pathname.split("/").filter(Boolean);
  if (parts[0] === "en" || parts[0] === "es") parts.shift();
  return "/" + parts.join("/");
}

/**
 * Gera URL com prefixo de locale (PT não tem prefixo).
 * ("/", "en") -> "/en"; ("/contato", "es") -> "/es/contato"; ("/contato", "pt") -> "/contato"
 */
export function withLocale(pathname: string, locale: Locale): string {
  const base = stripLocale(pathname);
  if (locale === "pt") return base;
  if (base === "/") return `/${locale}`;
  return `/${locale}${base}`;
}
